export { default as DashboardCardEntityTradingPairsSelection } from './component';
export * from './DashboardCardEntityTradingPairsSelection.proptypes';
